// extracted by css-extract-rspack-plugin
export default {"divider":"pAGbDq"};